import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { FileInfo } from ".";
import { mapUnsanitizedFilesToFiles } from "./utils";
import { parseQueryParamsObject } from "@robe/core-utils";
import { NotFoundError } from "../errors";

export const getFilesInfo = (ids: number[], core: XcoreCore): BaseApiRequest<FileInfo[]> =>
  core
    .fetch(`/api/files/info${parseQueryParamsObject({ ids })}`)
    .then(async (r) => await r.json())
    .then((files) => (files ? mapUnsanitizedFilesToFiles(files) : []))
    .catch((err) => {
      if (err instanceof NotFoundError) {
        return [];
      }

      throw err;
    });
